


































































































import {
  defineComponent,
  ref,
  computed,
  PropType,
  watch
} from '@vue/composition-api';
import { ALForm } from '@/common/component.types';
import { AxiosError } from 'axios';

import { setErrorFromAxiosError } from '@/utils/helpers';
import { IGenPaymentPlanScheduleInvoicePayload } from '@/composable/payment-plan';
import { useCreatePaymentPlanScheduleInvoice } from '@/composable/payment-plan';
import { cloneDeep } from 'lodash';
import { requiredValidator } from '@/utils/validators';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import ALDialog from '@/components/core/Dialog/ALDialog.vue';
import CountryPicker from '@/components/common/CountryPicker.vue';

export default defineComponent({
  name: 'PaymentPlanScheduleInvoiceCountryDialog',
  components: {
    ErrorAlert,
    ALDialog,
    CountryPicker
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    paymentPlanId: {
      type: Number,
      required: true
    },
    payload: {
      type: Object as PropType<IGenPaymentPlanScheduleInvoicePayload | null>
    }
  },
  emits: ['update:dialog'],
  setup(props, { emit, root }) {
    const localDialog = computed({
      get: () => props.dialog,
      set: value => {
        emit('update:dialog', value);
      }
    });

    const payloadData = ref<IGenPaymentPlanScheduleInvoicePayload>();

    const currentPaymentPlanId = computed(() => props.paymentPlanId);

    watch(localDialog, value => {
      if (value) {
        clearErrors();

        payloadData.value = props.payload
          ? cloneDeep(props.payload)
          : {
              scheduleId: 0,
              data: {
                buyer_country: '',
                shipping_country: ''
              }
            };
      }
    });

    const formRef = ref<ALForm | null>(null);
    const valid = ref(false);

    function closeDialog() {
      clearErrors();
      resetFormValidation();
      localDialog.value = false;
    }

    const {
      isLoading,
      error: createError,
      mutate: createScheduleInvoice,
      reset: resetScheduleInvoice
    } = useCreatePaymentPlanScheduleInvoice(currentPaymentPlanId);

    const error = computed(() => {
      return createError.value
        ? setErrorFromAxiosError(createError.value as AxiosError)
        : null;
    });

    function clearErrors() {
      resetScheduleInvoice();
      createError.value = null;
    }

    function resetFormValidation(): void {
      if (formRef.value) {
        return formRef.value.resetValidation();
      }
    }

    function validateForm(): boolean {
      let valid = false;
      if (formRef.value) {
        valid = formRef.value.validate();
      }
      return valid;
    }

    async function save() {
      clearErrors();
      const valid = await validateForm();

      if (valid) {
        createScheduleInvoice(payloadData.value!, {
          onSuccess: data => {
            root.$router.push({
              name: 'invoice-detail',
              params: {
                id: data.id!.toString()
              }
            });
            closeDialog();
          }
        });
      }
    }

    return {
      localDialog,
      isLoading,
      error,
      payloadData,
      formRef,
      valid,
      closeDialog,
      clearErrors,
      save,
      requiredValidator
    };
  }
});
